import { api } from '@/lib/http-client';
import type {
  CreatePaymentMethodRequest,
  PaymentMethod,
  UpdatePaymentMethodRequest,
} from '@/types/settings';

/**
 * Módulo 2 — Métodos de pago del negocio (`docs/openapi.yaml` → tag `Payment methods`).
 *
 * El listado lo ve cualquier miembro; crear/editar/borrar es solo ADMIN. `datos` es un JSON
 * libre (número de cuenta, titular…) y `condiciones` texto libre.
 */

/** `GET /api/tenants/:tenantId/payment-methods` — ordenados por creación. */
export function listPaymentMethods(tenantId: string): Promise<PaymentMethod[]> {
  return api.get<PaymentMethod[]>(`/api/tenants/${tenantId}/payment-methods`);
}

/** `POST /api/tenants/:tenantId/payment-methods` (solo ADMIN). */
export function createPaymentMethod(
  tenantId: string,
  payload: CreatePaymentMethodRequest,
): Promise<PaymentMethod> {
  return api.post<PaymentMethod>(`/api/tenants/${tenantId}/payment-methods`, payload);
}

/** `PATCH /api/tenants/:tenantId/payment-methods/:paymentMethodId` (solo ADMIN). */
export function updatePaymentMethod(
  tenantId: string,
  paymentMethodId: string,
  payload: UpdatePaymentMethodRequest,
): Promise<PaymentMethod> {
  return api.patch<PaymentMethod>(
    `/api/tenants/${tenantId}/payment-methods/${paymentMethodId}`,
    payload,
  );
}

/** `DELETE /api/tenants/:tenantId/payment-methods/:paymentMethodId` (solo ADMIN). */
export function deletePaymentMethod(
  tenantId: string,
  paymentMethodId: string,
): Promise<{ deleted: boolean }> {
  return api.delete<{ deleted: boolean }>(
    `/api/tenants/${tenantId}/payment-methods/${paymentMethodId}`,
  );
}
